var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7621 17.5259L10.7618 17.5259C10.3729 17.5643 10.0667 17.2181 10.1035 16.8397L10.1035 16.84L10.7621 17.5259ZM10.7621 17.5259L14.3307 17.1643C14.4826 17.1609 14.6311 17.0978 14.7444 16.9799L14.7444 16.9799L25.275 6.02666C25.275 6.02665 25.275 6.02665 25.275 6.02665C27.0466 4.18438 25.8747 0.981293 23.341 0.879002V0.875H23.216C22.4693 0.875 21.7229 1.16984 21.1571 1.75831L10.625 12.7116L10.5417 12.7982L10.5513 12.8082C10.4982 12.8909 10.4634 12.988 10.4545 13.0942L10.7621 17.5259ZM10.4544 13.0948L10.1035 16.8395L10.4544 13.0948ZM2.0865 5.49903V5.49902C2.0865 4.45017 2.90776 3.60325 3.90456 3.60325H16.6662C16.8608 3.60325 17.0147 3.52498 17.118 3.40266C17.2189 3.2831 17.2662 3.12823 17.2662 2.97828C17.2662 2.82832 17.2189 2.67345 17.118 2.55389C17.0147 2.43157 16.8608 2.3533 16.6662 2.3533H3.90456C2.23465 2.3533 0.875 3.77451 0.875 5.49902V23.9793C0.875 25.7052 2.23175 27.125 3.90456 27.125H21.6742C23.344 27.125 24.7037 25.7053 24.7037 23.9793L24.7023 10.7072C24.7023 10.5098 24.6291 10.352 24.5114 10.2445C24.3956 10.1387 24.2443 10.0882 24.0965 10.0882C23.9488 10.0882 23.7974 10.1387 23.6817 10.2445C23.5639 10.352 23.4908 10.5098 23.4908 10.7073V23.9793C23.4908 25.0238 22.6693 25.875 21.6727 25.875H3.90312C2.90919 25.875 2.08506 25.0252 2.08506 23.9793L2.0865 5.49903ZM23.2917 2.12325C24.7531 2.18349 25.4667 4.05541 24.4186 5.14543L14.0372 15.9405L11.3769 16.211L11.6381 13.4344L22.0195 2.63776L22.0197 2.63758C22.3492 2.29354 22.7847 2.12325 23.2191 2.12325H23.2917Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.25
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.899ef8229fb05aa0daa31fef83ca9436.svg";
export { ForwardRef as ReactComponent };